module.exports = __webpack_public_path__ + "media/images/icon__infoBox@2x-0e4e180e6dfcfad1c989767bc3e3e47e.png";